module.exports = __webpack_public_path__ + "static/media/recommendation@3x.a6c2171e.png";